export const translations = {
  pt: {
    brand: "StayZen",
    nav: {
      home: "Início",
      services: "Serviços",
      houses: "Casas",
      contact: "Contacto",
      login: "Área Cliente",
      dashboard: "Dashboard",
      logout: "Sair",
      admin: "Admin",
    },
    hero: {
      overline: "Gestão de alojamento local",
      title_1: "A tranquilidade de confiar",
      title_2: "a sua casa a quem",
      title_3: "cuida dos detalhes.",
      subtitle:
        "Na StayZen tratamos do seu alojamento local como se fosse nosso. Gerimos as reservas, a limpeza e a comunicação com os hóspedes — para que possa descansar enquanto a sua casa trabalha por si.",
      cta_primary: "Falar connosco",
      cta_secondary: "Ver as nossas casas",
    },
    about: {
      overline: "Sobre a StayZen",
      title: "Gestão completa, serena e à sua medida.",
      body: "Somos uma empresa portuguesa dedicada à gestão de alojamentos locais. Cuidamos de todos os aspetos operacionais — do anúncio à entrega das chaves — com um padrão de exigência que preserva o valor e a identidade da sua casa.",
      bullets: [
        "Gestão completa do alojamento.",
        "Apoio aos hóspedes 24/7.",
        "Limpeza profissional do imóvel.",
        "Check-in e check-out.",
        "Sessão fotográfica do alojamento.",
      ],
    },
    services: {
      overline: "Os nossos serviços",
      title: "Tudo o que a sua casa precisa, num só lugar.",
      list: [
        {
          title: "Gestão de reservas",
          desc: "Otimizamos preços, publicamos nas principais plataformas e tratamos da comunicação com os hóspedes 24/7.",
        },
        {
          title: "Limpeza e manutenção",
          desc: "Equipas locais certificadas garantem um padrão consistente entre cada estadia, com reposição de consumíveis.",
        },
        {
          title: "Check-in e acolhimento",
          desc: "Recebemos os seus hóspedes presencialmente ou via self check-in, sempre com um toque de hospitalidade portuguesa.",
        },
        {
          title: "Relatórios mensais",
          desc: "Veja a qualquer momento no seu dashboard a ocupação, os ganhos e todas as despesas associadas.",
        },
      ],
    },
    houses: {
      overline: "Portfólio",
      title: "Casas que já fazem parte da família StayZen.",
      view: "Ver detalhes",
      book: "Reservar",
      guests: "hóspedes",
      bedrooms: "quartos",
      bathrooms: "casas de banho",
      per_night: "/ noite",
      from: "desde",
    },
    reserve: {
      overline: "Reservar estadia",
      title_prefix: "Reservar",
      subtitle:
        "Escolha as suas datas e número de hóspedes. Os dias a cinzento já estão ocupados.",
      availability: "Disponibilidade",
      legend_available: "Disponível",
      legend_occupied: "Ocupado",
      legend_selected: "Seleção",
      check_in: "Check-in",
      check_out: "Check-out",
      guests_count: "Nº de hóspedes",
      name: "Nome completo",
      email: "Email",
      phone: "Telefone",
      message: "Mensagem (opcional)",
      nights: "noites",
      select_dates: "Escolha check-in e check-out",
      submit: "Pagar e reservar",
      paying: "A criar pagamento…",
      nightly_price: "Preço por noite",
      total: "Total",
      success: "Reserva confirmada!",
      conflict: "Essas datas já estão ocupadas. Escolha outro período.",
      error: "Não foi possível enviar o pedido.",
      back: "Voltar ao portfólio",
      house_details: "Detalhes da casa",
    },
    calculator: {
      overline: "Calculadora de receita",
      title: "Quanto pode a sua casa render?",
      subtitle:
        "Uma estimativa em segundos — baseada nos dados reais do mercado de Lisboa e arredores. A StayZen cuida de tudo; o proprietário recebe líquido.",
      type_label: "Tipologia",
      type_options: [
        { value: "t0", label: "T0 · Estúdio" },
        { value: "t1", label: "T1 · 1 quarto" },
        { value: "t2", label: "T2 · 2 quartos" },
        { value: "t3", label: "T3 · 3 quartos" },
        { value: "t4", label: "T4+ · 4 ou mais quartos" },
      ],
      location_label: "Zona",
      location_options: [
        { value: "principe_real", label: "Príncipe Real / Avenidas" },
        { value: "baixa_chiado", label: "Baixa / Chiado" },
        { value: "alfama", label: "Alfama / Castelo" },
        { value: "belem", label: "Belém / Ajuda" },
        { value: "parque_nacoes", label: "Parque das Nações" },
        { value: "estrela_lapa", label: "Estrela / Lapa" },
        { value: "campo_ourique", label: "Campo de Ourique" },
        { value: "alvalade", label: "Alvalade / Areeiro" },
        { value: "cascais", label: "Cascais / Estoril" },
        { value: "sintra", label: "Sintra" },
        { value: "almada", label: "Almada / Costa da Caparica" },
        { value: "outra", label: "Outra zona" },
      ],
      amenities_label: "Comodidades",
      amenities_options: [
        { value: "sea_view", label: "Vista mar/rio" },
        { value: "pool", label: "Piscina" },
        { value: "ac", label: "Ar condicionado" },
        { value: "parking", label: "Estacionamento" },
        { value: "balcony", label: "Varanda/terraço" },
      ],
      al_label: "Já tem registo de Alojamento Local?",
      al_options: [
        { value: "self", label: "Sim, faço a gestão sozinho(a)" },
        { value: "other_company", label: "Sim, tenho outra empresa a gerir" },
        { value: "none", label: "Ainda não tenho AL registado" },
      ],
      nights_label: "Noites arrendadas por mês",
      compare_own: "Gestão própria (média do mercado)",
      compare_own_hint: "por mês, bruto",
      compare_stayzen: "Com StayZen",
      compare_stayzen_hint: "por mês, líquido",
      result_title: "Receita estimada",
      monthly: "por mês",
      yearly: "por ano",
      fee_note: "Valor líquido após a gestão StayZen (18% sobre o bruto).",
      cta: "Marcar uma reunião com a StayZen",
      email_prompt: "Quer receber esta simulação detalhada no seu email?",
      email_placeholder: "o-seu@email.pt",
      send_sim: "Enviar simulação para o meu email",
      sent_ok: "Simulação enviada. Verifique a sua caixa de entrada.",
      sent_err: "Não foi possível enviar. Tente novamente.",
      saved_ok: "Simulação registada. Em breve entraremos em contacto.",
      disclaimer:
        "Estimativa baseada em dados reais de mercado. A proposta final é calculada com base na sua casa, fotografia profissional e estratégia de pricing dinâmico.",
    },
    meeting: {
      overline: "Marcação de reunião",
      title: "Vamos falar sobre a sua casa.",
      subtitle:
        "Escolha o dia e a hora que melhor lhe convêm. Ao submeter, abre-se também o seu cliente de email com a mensagem pronta para enviar à nossa equipa — é o seu pedido formal de reunião.",
      name: "Nome completo",
      email: "Email",
      phone: "Telefone",
      date: "Data preferida",
      time: "Hora preferida",
      message: "Quer partilhar algo sobre a sua casa? (opcional)",
      submit: "Enviar pedido de reunião",
      success: "Pedido registado! Abrimos o seu cliente de email para finalizar o envio.",
      error: "Não foi possível enviar o pedido.",
      back: "Voltar ao início",
      email_subject: "Pedido de reunião — StayZen",
      email_to: "stayzenpremium@gmail.com",
    },
    contact: {
      overline: "Vamos conversar",
      title: "Pronto para confiar a sua casa a quem dela cuida?",
      name: "Nome",
      email: "Email",
      phone: "Telefone",
      message: "Mensagem",
      submit: "Enviar mensagem",
      success: "Mensagem enviada. Entraremos em contacto em breve.",
      error: "Não foi possível enviar. Tente novamente.",
    },
    footer: {
      rights: "Todos os direitos reservados.",
      tagline: "Gestão serena de alojamento local.",
    },
    login: {
      title: "Área do cliente",
      subtitle: "Aceda ao desempenho da sua casa.",
      email: "Email",
      password: "Palavra-passe",
      submit: "Entrar",
      or: "ou",
      google: "Continuar com o Google",
      register_prompt: "Ainda não tem conta?",
      register_link: "Criar conta",
      register_title: "Criar a sua conta",
      register_submit: "Criar conta",
      name: "Nome completo",
      back_login: "Já tenho conta",
      invalid: "Credenciais inválidas.",
    },
    dashboard: {
      welcome: "Bem-vindo(a)",
      subtitle: "Aqui está o desempenho da sua casa.",
      no_house: "Ainda não há uma casa associada à sua conta. A nossa equipa irá configurá-la em breve.",
      metrics: {
        earnings: "Rendimento total",
        bookings: "Reservas",
        guests: "Hóspedes recebidos",
        cleanings: "Limpezas realizadas",
        occupancy: "Taxa de ocupação",
      },
      earnings_chart: "Rendimento mensal",
      recent_bookings: "Reservas recentes",
      table: {
        guest: "Hóspede",
        check_in: "Check-in",
        check_out: "Check-out",
        nights: "Noites",
        guests: "Hóspedes",
        amount: "Valor",
      },
      empty: "Sem dados ainda.",
    },
    admin: {
      title: "Painel de administração",
      subtitle: "Gerir casas, clientes e reservas.",
      tabs: { houses: "Casas", users: "Clientes", bookings: "Reservas", cleanings: "Limpezas", maintenance: "Manutenção", reviews: "Avaliações", testimonials: "Testemunhos", meetings: "Reuniões", simulations: "Simulações", reservations: "Pedidos de reserva", ai_pricing: "IA de Preços", calendar: "Calendário", conversations: "Conversas" },
      add_house: "Adicionar casa",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      assign: "Associar casa",
      fields: {
        name: "Nome",
        location: "Localização",
        description: "Descrição",
        cover: "URL da imagem principal",
        bedrooms: "Quartos",
        bathrooms: "Casas de banho",
        max_guests: "Hóspedes máx.",
        house_id: "Casa",
        guest_name: "Hóspede",
        check_in: "Check-in",
        check_out: "Check-out",
        nights: "Noites",
        guests_count: "Nº hóspedes",
        amount: "Valor (€)",
        date: "Data",
        cost: "Custo (€)",
        status: "Estado",
      },
      add_booking: "Adicionar reserva",
      add_cleaning: "Adicionar limpeza",
    },
    stats: {
      overline: "Confiança em números",
      title: "Resultados que falam por si",
      houses: "casas em gestão",
      guests: "hóspedes recebidos",
      rating: "avaliação média",
      occupancy: "taxa média de ocupação",
    },
    testimonials: {
      overline: "Quem confia na StayZen",
      title: "Proprietários que dormem descansados.",
      subtitle: "A confiança constrói-se com resultados consistentes. Estes são alguns dos proprietários que partilham connosco a gestão das suas casas.",
    },
    compare: {
      overline: "A diferença StayZen",
      title: "Antes e depois de delegar.",
      subtitle: "Aquilo que muda no seu dia-a-dia quando entrega a gestão a quem se dedica a isto a tempo inteiro.",
      header_before: "Sem gestão profissional",
      header_after: "Com a StayZen",
      rows: [
        { label: "Reservas", before: "Gerir 3 plataformas e mensagens 24/7", after: "Otimização multi-plataforma + comunicação em 4 línguas" },
        { label: "Hóspedes", before: "Telefones a qualquer hora", after: "Apoio 24/7 dedicado pela nossa equipa" },
        { label: "Check-in & check-out", before: "Disponibilidade total da sua parte", after: "Equipa local entrega e recebe chaves" },
        { label: "Limpeza & manutenção", before: "Coordenar fornecedores avulsos", after: "Equipa profissional contratada e supervisionada" },
        { label: "Preço por noite", before: "Preço fixo, perdendo épocas altas", after: "Preços dinâmicos que sobem receita até 30%" },
        { label: "Transparência", before: "Folhas Excel improvisadas", after: "Dashboard em tempo real + relatório PDF mensal" },
      ],
    },
    faq: {
      overline: "Perguntas frequentes",
      title: "Tudo o que precisa de saber antes de avançar.",
      items: [
        { q: "Qual é a comissão da StayZen?", a: "Trabalhamos com uma comissão fixa sobre a receita líquida da reserva. O valor exato depende da casa e do plano (com ou sem manutenção). Apresentamos sempre tudo por escrito, sem custos escondidos." },
        { q: "Tenho contrato de exclusividade?", a: "Não. O contrato é flexível e pode ser denunciado com aviso prévio. Acreditamos que a relação se mantém pelos resultados, não pela letra pequena." },
        { q: "Em quanto tempo a minha casa começa a receber hóspedes?", a: "Tipicamente entre 7 e 14 dias após a assinatura do contrato — incluindo sessão fotográfica, criação dos anúncios e configuração dos sistemas de pricing." },
        { q: "Quem trata da limpeza e da manutenção?", a: "Temos uma equipa profissional contratada. Toda a limpeza é registada no seu dashboard. Se optar pelo plano com manutenção, intervenções menores são também tratadas por nós, com fotos antes/depois." },
        { q: "Como recebo o pagamento?", a: "Pagamos mensalmente, por transferência bancária, juntamente com o relatório PDF detalhado de todas as reservas, limpezas, manutenções e avaliações do mês." },
        { q: "Posso usar a minha casa quando quiser?", a: "Sim, claro. Basta bloquear as datas no seu dashboard e tratamos do resto. A casa continua a ser sua." },
        { q: "Em que plataformas a minha casa fica anunciada?", a: "Airbnb, Booking.com, Vrbo e o nosso próprio site StayZen. Sincronizamos os calendários em tempo real para evitar overbookings." },
        { q: "Como acompanho o desempenho da casa?", a: "Tem acesso permanente a um dashboard privado com ganhos, número de hóspedes, reservas, limpezas, taxa de ocupação, calendário visual, manutenções e avaliações — em tempo real." },
      ],
    },
  },
  en: {
    brand: "StayZen",
    nav: {
      home: "Home",
      services: "Services",
      houses: "Houses",
      contact: "Contact",
      login: "Client Area",
      dashboard: "Dashboard",
      logout: "Sign out",
      admin: "Admin",
    },
    hero: {
      overline: "Short-term rental management",
      title_1: "The quiet confidence",
      title_2: "of trusting your home",
      title_3: "to a team that notices.",
      subtitle:
        "At StayZen we care for your short-term rental as if it were our own. We handle bookings, cleanings and guest communication — so you can rest while your home works for you.",
      cta_primary: "Get in touch",
      cta_secondary: "See our homes",
    },
    about: {
      overline: "About StayZen",
      title: "Full, serene and tailored management.",
      body: "We are a Portuguese company dedicated to managing short-term rentals. From the listing to the keys, we take care of every operational detail while preserving the value and identity of your home.",
      bullets: [
        "Full property management.",
        "24/7 guest support.",
        "Professional property cleaning.",
        "Check-in and check-out.",
        "Property photo session.",
      ],
    },
    services: {
      overline: "Our services",
      title: "Everything your home needs, in one place.",
      list: [
        {
          title: "Booking management",
          desc: "We optimise pricing, publish on the main platforms and handle all guest communication 24/7.",
        },
        {
          title: "Cleaning & maintenance",
          desc: "Certified local teams guarantee a consistent standard between stays, with consumables always restocked.",
        },
        {
          title: "Check-in & hospitality",
          desc: "We welcome your guests in person or via self check-in, always with a Portuguese sense of hospitality.",
        },
        {
          title: "Monthly reports",
          desc: "See your occupancy, earnings and expenses in your dashboard at any moment.",
        },
      ],
    },
    houses: {
      overline: "Portfolio",
      title: "Homes that are already part of the StayZen family.",
      view: "View details",
      book: "Book now",
      guests: "guests",
      bedrooms: "bedrooms",
      bathrooms: "bathrooms",
      per_night: "/ night",
      from: "from",
    },
    reserve: {
      overline: "Book your stay",
      title_prefix: "Book",
      subtitle:
        "Choose your dates and number of guests. Greyed-out days are already booked.",
      availability: "Availability",
      legend_available: "Available",
      legend_occupied: "Occupied",
      legend_selected: "Selection",
      check_in: "Check-in",
      check_out: "Check-out",
      guests_count: "Guests",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      message: "Message (optional)",
      nights: "nights",
      select_dates: "Pick check-in and check-out",
      submit: "Pay & book",
      paying: "Opening checkout…",
      nightly_price: "Nightly price",
      total: "Total",
      success: "Reservation confirmed!",
      conflict: "Those dates are already taken. Please pick another range.",
      error: "Couldn't send the request.",
      back: "Back to portfolio",
      house_details: "House details",
    },
    calculator: {
      overline: "Revenue calculator",
      title: "How much could your home earn?",
      subtitle:
        "An estimate in seconds — based on real market data for Lisbon and surrounding areas. StayZen handles everything; the owner takes the net income home.",
      type_label: "Property type",
      type_options: [
        { value: "t0", label: "T0 · Studio" },
        { value: "t1", label: "T1 · 1 bedroom" },
        { value: "t2", label: "T2 · 2 bedrooms" },
        { value: "t3", label: "T3 · 3 bedrooms" },
        { value: "t4", label: "T4+ · 4 or more bedrooms" },
      ],
      location_label: "Zone",
      location_options: [
        { value: "principe_real", label: "Príncipe Real / Avenidas" },
        { value: "baixa_chiado", label: "Baixa / Chiado" },
        { value: "alfama", label: "Alfama / Castelo" },
        { value: "belem", label: "Belém / Ajuda" },
        { value: "parque_nacoes", label: "Parque das Nações" },
        { value: "estrela_lapa", label: "Estrela / Lapa" },
        { value: "campo_ourique", label: "Campo de Ourique" },
        { value: "alvalade", label: "Alvalade / Areeiro" },
        { value: "cascais", label: "Cascais / Estoril" },
        { value: "sintra", label: "Sintra" },
        { value: "almada", label: "Almada / Costa da Caparica" },
        { value: "outra", label: "Other zone" },
      ],
      amenities_label: "Amenities",
      amenities_options: [
        { value: "sea_view", label: "Sea/river view" },
        { value: "pool", label: "Pool" },
        { value: "ac", label: "Air conditioning" },
        { value: "parking", label: "Parking" },
        { value: "balcony", label: "Balcony/terrace" },
      ],
      al_label: "Do you already have a Local Lodging (AL) licence?",
      al_options: [
        { value: "self", label: "Yes, I manage it myself" },
        { value: "other_company", label: "Yes, but another company manages it" },
        { value: "none", label: "I don't have an AL licence yet" },
      ],
      nights_label: "Nights rented per month",
      compare_own: "Self-management (market average)",
      compare_own_hint: "per month, gross",
      compare_stayzen: "With StayZen",
      compare_stayzen_hint: "per month, net",
      result_title: "Estimated revenue",
      monthly: "per month",
      yearly: "per year",
      fee_note: "Net value after StayZen management (18% on gross).",
      cta: "Book a meeting with StayZen",
      email_prompt: "Want this simulation in your inbox?",
      email_placeholder: "you@email.com",
      send_sim: "Send simulation to my email",
      sent_ok: "Simulation sent. Check your inbox.",
      sent_err: "Couldn't send. Please try again.",
      saved_ok: "Simulation saved. We'll reach out shortly.",
      disclaimer:
        "Estimate based on real market data. The final proposal is calculated based on your actual home, professional photography and dynamic pricing strategy.",
    },
    meeting: {
      overline: "Book a meeting",
      title: "Let's talk about your home.",
      subtitle:
        "Choose the day and time that suits you best. On submit we also open your email client with the message ready to send to our team — that's your formal meeting request.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      date: "Preferred date",
      time: "Preferred time",
      message: "Anything you'd like to share about your home? (optional)",
      submit: "Send meeting request",
      success: "Request saved! We've opened your email client to finalize sending.",
      error: "Couldn't send the request.",
      back: "Back to home",
      email_subject: "Meeting request — StayZen",
      email_to: "stayzenpremium@gmail.com",
    },
    contact: {
      overline: "Let's talk",
      title: "Ready to trust your home to those who care for it?",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      submit: "Send message",
      success: "Message sent. We'll be in touch shortly.",
      error: "Couldn't send. Please try again.",
    },
    footer: {
      rights: "All rights reserved.",
      tagline: "Serene management of short-term rentals.",
    },
    login: {
      title: "Client area",
      subtitle: "Access your home's performance.",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      or: "or",
      google: "Continue with Google",
      register_prompt: "Don't have an account?",
      register_link: "Create account",
      register_title: "Create your account",
      register_submit: "Create account",
      name: "Full name",
      back_login: "I have an account",
      invalid: "Invalid credentials.",
    },
    dashboard: {
      welcome: "Welcome",
      subtitle: "Here is how your home is performing.",
      no_house: "No home is linked to your account yet. Our team will set this up shortly.",
      metrics: {
        earnings: "Total earnings",
        bookings: "Bookings",
        guests: "Guests hosted",
        cleanings: "Cleanings done",
        occupancy: "Occupancy rate",
      },
      earnings_chart: "Monthly earnings",
      recent_bookings: "Recent bookings",
      table: {
        guest: "Guest",
        check_in: "Check-in",
        check_out: "Check-out",
        nights: "Nights",
        guests: "Guests",
        amount: "Amount",
      },
      empty: "No data yet.",
    },
    admin: {
      title: "Admin panel",
      subtitle: "Manage houses, clients and bookings.",
      tabs: { houses: "Houses", users: "Clients", bookings: "Bookings", cleanings: "Cleanings", maintenance: "Maintenance", reviews: "Reviews", testimonials: "Testimonials", meetings: "Meetings", simulations: "Simulations", reservations: "Reservation requests", ai_pricing: "AI Pricing", calendar: "Calendar", conversations: "Conversations" },
      add_house: "Add house",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      assign: "Assign house",
      fields: {
        name: "Name",
        location: "Location",
        description: "Description",
        cover: "Cover image URL",
        bedrooms: "Bedrooms",
        bathrooms: "Bathrooms",
        max_guests: "Max guests",
        house_id: "House",
        guest_name: "Guest",
        check_in: "Check-in",
        check_out: "Check-out",
        nights: "Nights",
        guests_count: "Guests count",
        amount: "Amount (€)",
        date: "Date",
        cost: "Cost (€)",
        status: "Status",
      },
      add_booking: "Add booking",
      add_cleaning: "Add cleaning",
    },
    stats: {
      overline: "Trust in numbers",
      title: "Results that speak for themselves",
      houses: "homes managed",
      guests: "guests welcomed",
      rating: "average rating",
      occupancy: "average occupancy",
    },
    testimonials: {
      overline: "Owners who trust StayZen",
      title: "Property owners who rest easy.",
      subtitle: "Trust is built on consistent results. Here are some of the owners who share with us the management of their homes.",
    },
    compare: {
      overline: "The StayZen difference",
      title: "Before and after delegating.",
      subtitle: "What changes in your daily life when you hand the management to a team that does this full-time.",
      header_before: "Without professional management",
      header_after: "With StayZen",
      rows: [
        { label: "Bookings", before: "Managing 3 platforms and messages 24/7", after: "Multi-platform optimisation + guest comms in 4 languages" },
        { label: "Guests", before: "Calls at any hour", after: "Dedicated 24/7 support from our team" },
        { label: "Check-in & check-out", before: "Always on call yourself", after: "Local team handles keys, every time" },
        { label: "Cleaning & maintenance", before: "Coordinating one-off suppliers", after: "Professional staff hired and supervised by us" },
        { label: "Nightly rate", before: "Flat price, missing high seasons", after: "Dynamic pricing that lifts revenue up to 30%" },
        { label: "Transparency", before: "Improvised spreadsheets", after: "Real-time dashboard + monthly PDF report" },
      ],
    },
    faq: {
      overline: "Frequently asked questions",
      title: "Everything you need to know before moving forward.",
      items: [
        { q: "What is the StayZen commission?", a: "We work with a fixed commission on the net revenue of each booking. The exact rate depends on the home and plan (with or without maintenance). Everything is presented up-front, no hidden fees." },
        { q: "Do I have an exclusivity contract?", a: "No. The contract is flexible and can be cancelled with prior notice. We believe the relationship is built on results, not fine print." },
        { q: "How quickly will my home start receiving guests?", a: "Typically between 7 and 14 days after signing — including the photo shoot, listing creation and pricing setup." },
        { q: "Who handles cleaning and maintenance?", a: "We have a professional in-house team. Every cleaning is logged in your dashboard. If you opt for the maintenance plan, smaller interventions are also handled by us with before/after photos." },
        { q: "How am I paid?", a: "Monthly bank transfer along with a detailed PDF report of bookings, cleanings, maintenance and reviews." },
        { q: "Can I use my own home whenever I want?", a: "Of course. Just block the dates on your dashboard and we take care of the rest. It's still your home." },
        { q: "Which platforms is my home listed on?", a: "Airbnb, Booking.com, Vrbo and our own StayZen website. Calendars are synced in real time to avoid overbookings." },
        { q: "How do I track my home's performance?", a: "You have permanent access to a private dashboard with earnings, guests, bookings, cleanings, occupancy rate, visual calendar, maintenance and reviews — in real time." },
      ],
    },
  },
};

export const defaultLang = "pt";
